import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { HeaderBanner } from '@rsmus/rsm-catt-ui';
import { useAppSelector } from 'store/app/hooks';
import { RootState } from 'store/app/store';
import BreadcrumbNav from 'cui/components/breadcrumb/BreadcrumbNav';
import WelcomeBanner from 'cui/components/welcomeBanner/welcomeBanner';
import { RoutePaths } from 'utils/RoutePaths';
  
export const SharedLayoutHeaderBanner: React.FunctionComponent = () => {

    const location = useLocation();
    const path = location.pathname;
    const breadCrumbsState = useAppSelector((state: RootState) => state.breadcrumbs);
    const [areBreadcrumbsEnabled, setBreadcrumbsEnabled ] = useState(false);
    const [redirectToHome, setRedirectToHome] = useState(false);
    const [showHeaderBanner, setShowHeaderBanner] = useState(true);
    
    useEffect(() => {
      setShowHeaderBanner(true)
      switch (true) {
        case path.includes(`/${RoutePaths.User.UserDashboard}`):
          setBreadcrumbsEnabled(true);
          setRedirectToHome(true);
          break;
        case path.includes(`/${RoutePaths.Admin.WorkspaceReports}`):
          setBreadcrumbsEnabled(true);
          setRedirectToHome(false);
          break;
        case path.includes(`/${RoutePaths.User.Reports}`):
          setShowHeaderBanner(false);
          setBreadcrumbsEnabled(false);
          break;
        case path.includes(`/${RoutePaths.Admin.ClientAdmitReportAudit}`):
          setBreadcrumbsEnabled(true);
          setRedirectToHome(true);
          break;
        case path.includes(`/${RoutePaths.Admin.UserReportsAudit}`):
          setBreadcrumbsEnabled(true);
          setRedirectToHome(true);
          break;
        default:
          setBreadcrumbsEnabled(false);
          setShowHeaderBanner(true);
      }
    }, [location])

    const headerBannerInfo = {
        widgetSubTitle: breadCrumbsState.bannerText,
        widgetTitle: breadCrumbsState.bannerCount
    };
    
    const headerContent = (areBreadcrumbsEnabled)
    ? <BreadcrumbNav redirectToHome={redirectToHome}/>
    : <WelcomeBanner />
    
    return <>{showHeaderBanner && (
        <HeaderBanner bannerWidgetInfo={[headerBannerInfo]}>{headerContent}</HeaderBanner>
      )
    } </>;
};